import { TranslateService } from '@ngx-translate/core';
import { Injectable, Injector } from '@angular/core';
import { AlertService } from './alert.service';
import { StorageService } from './storage.service';
import { RouteService } from './route.service';
import { UserService } from './user.service';
import { WmPoolErrorResponse } from '../interfaces/api-response.interface';
import { WmMmsErrorResponse } from '../interfaces/api-response.interface';
import { environment } from '../environments/environment';
import { CurrentAppService } from './current-app.service';

export class WmError {
  constructor(public status: boolean, public data: unknown, public message: string, public errorCode: string, public translatedMessage: string) {}

  toString = () => this.translatedMessage || this.message;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  env = environment;
  app!: string;

  constructor(
    private injector: Injector,
    private alertService: AlertService,
    private storageService: StorageService,
    private routeService: RouteService,
    private userService: UserService,
    private currentAppService: CurrentAppService
  ) {
    this.app = this.currentAppService.currentApp;
  }

  isPoolBackendErrorResponse(error: WmPoolErrorResponse | WmMmsErrorResponse): error is WmPoolErrorResponse {
    return (error as WmPoolErrorResponse).errorCode !== undefined;
  }

  isMmsBackendErrorResponse(error: WmPoolErrorResponse | WmMmsErrorResponse): error is WmMmsErrorResponse {
    return (error as WmMmsErrorResponse).code !== undefined;
  }

  handle(error: WmPoolErrorResponse | WmMmsErrorResponse) {
    const translate = this.injector.get(TranslateService);
    // handle pool backend error responses
    if (this.isPoolBackendErrorResponse(error)) {
      let translateMessage = translate.instant(`ERRORS.${error.errorCode}`);

      if (translateMessage === `ERRORS.${error.errorCode}`) {
        translateMessage = null;
      }

      if (error.errorCode === 'USER_UNAUTHORIZED') {
        switch (this.app) {
          case 'wm-admin':
            this.storageService.removeAdminToken();
            window.location.href = this.env.adminDomain + '/auth/sign-in';
            break;
          case 'wm-tech':
            this.storageService.removeToken();
            this.routeService.goToLogin();
            break;
          case 'wm-tech-mms':
            this.storageService.removeToken();
            window.location.href = this.env.techDomain + '/auth/sign-in';
            break;
          case 'wm-tech-pool':
            this.storageService.removeToken();
            window.location.href = this.env.techDomain + '/auth/sign-in';
            break;
          default:
            break;
        }
      }

      if (error.errorCode === 'TFA_ERROR') {
        this.userService.setNeedTfa(true);
      }

      if (error.errorCode === 'INVALID_ACCESS_TOKEN') {
        window.location.href = this.env.techDomain + '/page-not-found';
      }

      this.alertService.showAlert(translate.instant(`ERRORS.${error.errorCode}`), 'error');
      return new WmError(error.status, error.data, error.message, error.errorCode, translateMessage);

      // handle mms backend error responses
    } else if (this.isMmsBackendErrorResponse(error)) {
      let translateMessage = translate.instant(`ERRORS.${error.type}`);

      if (translateMessage === `ERRORS.${error.type}`) {
        translateMessage = null;
      }

      if (error.type === 'ERROR_TFA') {
        this.userService.setNeedTfa(true);
      }

      if (error.type === 'INVALID_ACCESS_TOKEN') {
        window.location.href = this.env.techDomain + '/page-not-found';
      }

      if (error.type === 'ERROR_UNAUTHORIZED') {
        switch (this.app) {
          case 'wm-tech-mms':
            this.storageService.removeToken();
            window.location.href = this.env.techDomain + '/auth/sign-in';
            break;
          default:
            break;
        }
      }

      this.alertService.showAlert(translate.instant(`ERRORS.${error.type}`), 'error');
      return new WmError(error.status, error.code, error.message, error.type, translateMessage);
    } else return;
  }
}

//todo
// "NOT_FOUND" code redirect to 404
